import { connect } from 'react-redux';
import { denormalize } from 'normalizr';
import { schema } from '../../../../../state/schema';
import { loadAdminPartnerClasses } from '../../../../../state/modules/adminPartnerClasses/actions';
import AdminPartnerClassInput from '../components/AdminPartnerClassInput';

const defaultLimit = 10;
const defaultOrder = 'name.asc';

const mapStateToProps = (state) => {
  const results = [].concat.apply(
    [],
    Object.entries(
      state.adminPartnerClasses.getIn(['pages', defaultOrder, defaultLimit], {})
    ).map(([k, v]) => v.toArray())
  );

  const list =
    results.length > 0
      ? results.map((x) => {
          return {
            key: x,
            ...denormalize(
              state.entities.getIn(['adminPartnerClasses', x]),
              schema.adminPartnerClass,
              state.entities.toJS()
            ),
          };
        })
      : [];

  return {
    options: list,
    isLoading: state.adminPartnerClasses.get('isLoading'),
    defaultLimit,
    defaultOrder,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    load: (
      page = 1,
      limit = defaultLimit,
      order = defaultOrder,
      filter = {},
      cb = function () {}
    ) => {
      dispatch(
        loadAdminPartnerClasses(
          page,
          limit,
          order,
          filter,
          (success, total) => {
            if (success) {
              // loop over all pages to get all events
              const pageCount = Math.ceil(total / limit);
              for (var i = 2; i <= pageCount; i++) {
                dispatch(loadAdminPartnerClasses(i, limit, order, filter));
              }
              cb();
            }
          }
        )
      );
    },
  };
};

const AdminPartnerClassInputContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(AdminPartnerClassInput);

export default AdminPartnerClassInputContainer;
